import { useState } from 'react';
import { bulkCreateTable } from '../../../ApiCalls/mantisFlowsBulks';
import { bulkCreateCostCenters } from '../../../ApiCalls/mantisFlowsBulks';
import { useToast } from '../../components/ui/use-toast';

export const useBulkUpload = (clientId, config) => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);
  const { toast } = useToast();

  const handleBulkUpload = async (items) => {
    setIsUploading(true);
    setUploadResult(null);

    // Validate clientId before proceeding
    if (!clientId) {
      console.error('useBulkUpload - clientId is undefined or null');
      toast({
        title: "Error",
        description: "Client ID is missing. Please refresh the page and try again.",
        variant: "destructive"
      });
      setIsUploading(false);
      return null;
    }

    try {
      let result;
      
      // Use specialized function for cost centers
      if (config.tableName === 'cost_centers') {
        result = await bulkCreateCostCenters(clientId, items, { user_name: 'Current User' });
      } else {
        // Use generic function for other tables
        result = await bulkCreateTable(clientId, config.tableName, items, { user_name: 'Current User' });
      }

      setUploadResult(result);

      if (result.success) {
        toast({
          title: "Success",
          description: `Successfully uploaded ${result.successfulItems} items${result.failedItems > 0 ? ` (${result.failedItems} items had validation errors and were skipped)` : ''}`,
          variant: "default"
        });
      } else if (result.canProceedWithValidItems) {
        // Don't show error toast if user can proceed with valid items
        // The UI will handle showing the proceed option
        return result;
      } else {
        toast({
          title: "Error",
          description: `Failed to upload ${result.failedItems} items. Check the details for more information.`,
          variant: "destructive"
        });
      }

      return result;
    } catch (error) {
      console.error('Error in bulk upload:', error);
      const errorResult = {
        success: false,
        message: error.message || 'Error in bulk upload',
        data: error
      };
      setUploadResult(errorResult);
      toast({
        title: "Error",
        description: "An unexpected error occurred during the upload",
        variant: "destructive"
      });
      return errorResult;
    } finally {
      setIsUploading(false);
    }
  };

  return {
    isUploading,
    uploadResult,
    handleBulkUpload
  };
}; 